import { render, staticRenderFns } from "./DeleteTypeSelect.vue?vue&type=template&id=26aaa796&scoped=true&lang=pug"
import script from "./DeleteTypeSelect.vue?vue&type=script&lang=js"
export * from "./DeleteTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aaa796",
  null
  
)

export default component.exports